import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "basic_info",
  "use": "basic_info-usage",
  "viewBox": "0 0 17 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 14\" id=\"basic_info\"><g fill-rule=\"evenodd\"><path d=\"M0 13.172h16.033V0H0v13.172zm1.5-1.5h13.033V1.5H1.5v10.172z\" /><path d=\"M3 7h4V3H3zM9 4h4V3H9zM9 7h4V6H9zM3 10h10V9H3z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id